import { hasBadContrast } from "color2k";

export function stringToColor(input: string) {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (input.codePointAt(i) || 0) + ((hash << 5) - hash);
  }
  // Avalanche the bits so short inputs (e.g. small user IDs) spread across the colour space
  hash ^= hash >>> 16;
  hash = Math.imul(hash, 0x45d9f3b);
  hash ^= hash >>> 16;
  const c = ((hash >>> 0) & 0x00_ff_ff_ff).toString(16).toUpperCase().padStart(6, "0");
  return `#${c}`;
}

export function getContrastingTextColor(hexColor: string) {
  if (hasBadContrast("#ffffff", "readable", hexColor)) {
    return "#000000"; // Black
  }

  return "#ffffff"; // White
}
